import { gql } from "@apollo/client";

export default gql`
  query getLocationStatesProvincesCities($params: GetStatesProvincesCitiesInput){
    getLocationStatesProvincesCities(params: $params){
        success
        data{
            docs{
                _id
                country{
                    _id
                    name
                    iso2
                    native
                    translations{
                        kr
                        pt_BR
                        pt
                        nl
                        hr
                        fa
                        de
                        ja
                        it
                        cn
                        tr
                    }
                    emoji
                    hasState
                    hasProvince
                    hasCity
                }
                stateProvince{
                    _id
                    country
                    stateProvince
                    name
                    type
                }
                name
                type
            }
            totalDocs
            hasNextPage
            hasPrevPage
        }
        code
        message
    }
}
`
